class BookTileController {

	public spreads: Array<any> = [];
	public bookID: string;

	public currentPage: number = 1;
	public totalPages: number;

	public tileContainer: any;

	public isLoading: boolean = false;
	public queueCount: number = 0;
	public actualPageNumbers: { [key: number]: number } = {};
	
	// @ngInject
	constructor(
		private $attrs,
		private bookService,
		private $location,
		private observerService
	) {}

	public $onInit = () => {
		this.bookID = this.$attrs.bookId
		this.queueGetSpreads();

		this.tileContainer = document.getElementById('tile-container');
		this.attachScrollLoading();

		this.observerService.attach( this.goToPage, 'goToPage' );
	}

	private getSpreads = (): void => {

		if ( this.totalPages < this.currentPage ) {
			return;
		}

		this.isLoading = true;

		this.bookService.getSpreadsForBook( this.bookID, this.currentPage, 16 ).then( result => {
			this.addSpreads( result.pages );
			this.totalPages = result.totalPages;

			let lastSpread = this.spreads[ this.spreads.length - 1 ];
			this.currentPage = ( 'undefined' !== typeof lastSpread.rightPage ) ? lastSpread.rightPage.pageNumber : lastSpread.leftPage.pageNumber;
			this.isLoading = false;

			if ( this.queueCount > 0 ) {
				this.currentPage++;
				this.queueCount--;
				this.getSpreads();
			}
		});
	}

	private queueGetSpreads = (): void => {
		if ( this.isLoading ) {
			this.queueCount++;
		} else {
			this.getSpreads();
		}

	}

	private addSpreads = ( spreads ) => {
		let oldSpreadLength = this.spreads.length
		this.spreads = this.spreads.concat( spreads );

		spreads.forEach( ( spread, index ) => {
			let fullIndex = oldSpreadLength + index;
			if (this.actualPageNumbers[fullIndex] === undefined) {
				this.actualPageNumbers[fullIndex] = (!spread.singleView || fullIndex % 2 === 0) ? spread.leftPage.pageNumber : spread.rightPage.pageNumber;
			}
			if ( 'undefined' !== typeof spread.cover ) {
				spreads[ index ].pageRange = this.bookService.getPageRepresentationFromSpread(spreads[index], spread.cover.pageNumber)['spreadPageRepresentation'];
			} else {
				spreads[ index ].pageRange = this.bookService.getPageRepresentationFromSpread(spreads[index], spread.leftPage.pageNumber)['spreadPageRepresentation'];
			}
		});
	}

	private attachScrollLoading = () => {

		// If there's no scrollbar, load more results.
		if ( this.tileContainer.scrollHeight === this.tileContainer.clientHeight ) {
			this.queueGetSpreads();
		}

		this.tileContainer.addEventListener( 'scroll', () => {

			let scrollBottomPosition = this.tileContainer.offsetHeight + this.tileContainer.scrollTop;
			if ( (this.tileContainer.scrollHeight - 2) <= scrollBottomPosition ) {
				this.getNextPage();
			}
		})
	}
	
	private getNextPage = () => {
		this.currentPage++;
		this.queueGetSpreads();
	}

	public goToPage = ( pageNumber: number ): void => {
		this.$location.search( 'view', null );
		window.location.href = `${this.$location.absUrl()}&pageNumber=${pageNumber}`;
	}

}

export { BookTileController };
